import 'izitoast/dist/css/iziToast.min.css'
import iZtoast from 'izitoast'

/**
 * Global toasts/notifications service
 * http://izitoast.marcelodolza.com/#Start
 */

const toast = {
  error: (
    message,
    title = 'Error',
    position = 'bottomRight',
    settings = {}
  ) => {
    iZtoast.settings(settings)
    return iZtoast.error({
      title: title,
      message: message,
      position: position
    })
  },
  success: (
    message,
    title = '',
    buttons = [],
    settings = {},
    position = 'bottomCenter',
    icon = 'mdi mdi-check-circle-outline'
  ) => {
    iZtoast.settings(settings)
    return iZtoast.success({
      message: message,
      title: title,
      position: position,
      icon: icon,
      buttons: buttons,
      backgroundColor: '#000000de',
      messageColor: '#FFFFFFFF',
      close: false,
      layout: 2,
      iconColor: '#FFF',
      timeout: false
    })
  },
  info: (
    message,
    title = 'Info',
    position = 'bottomRight',
    settings = {}
  ) => {
    iZtoast.settings(settings)
    return iZtoast.info({
      title: title,
      message: message,
      position: position
    })
  },
  warning: (
    message,
    title = 'Warning',
    position = 'bottomRight',
    settings = {}
  ) => {
    iZtoast.settings(settings)
    return iZtoast.warning({
      title: title,
      message: message,
      position: position
    })
  },
  acceptButtonProps: {
    text: 'Accept',
    clickAction: '',
    style: 'color:#26a69a; font-weight:bold; background-color:transparent; text-transform: uppercase;'
  },
  dismissButtonProps: {
    text: 'Dismiss',
    clickAction: '',
    style: 'color:#f0645a; font-weight:bold; background-color:transparent; padding-left:0px;  text-transform: uppercase;'
  },
  generateAcceptBtn: (
    acceptProp = {
      text: 'Accept',
      clickAction: '',
      style: 'color:#26a69a; font-weight:bold; background-color:transparent; text-transform: uppercase;'
    }
  ) => {
    return [
      '<button onclick="' + acceptProp.clickAction + '" style="' + acceptProp.style + '">' + acceptProp.text + '</button>',
      function (instance, toast) {
        // todo link to view/edit page
      },
      false
    ]
  },
  generateDismissBtn: (
    dismissProp = {
      text: 'Dismiss',
      clickAction: '',
      style: 'color:#f0645a; font-weight:bold; background-color:transparent; padding-left:0px;  text-transform: uppercase;'
    }
  ) => {
    return [
      '<button onclick="' + dismissProp.clickAction + '" style="' + dismissProp.style + '">' + dismissProp.text + '</button>',
      function (instance, toast) {
        instance.hide(
          {
            transitionOut: 'fadeOutUp'
          },
          toast
        )
      }
    ]
  }
}

export default toast
